import './styles.scss';

import React from 'react';
import PropTypes from 'prop-types';
import { I18n } from 'react-redux-i18n';
import { Link } from 'react-router';

import { forceHttpsUri } from 'Helpers/Uri';
import { getRouteByName } from 'Helpers/Routes';

export default class AlbumDetails extends React.Component {
    static propTypes = {
        album: PropTypes.shape({
            description: PropTypes.string,
            user: PropTypes.shape({
                username: PropTypes.string.isRequired,
                avatar: PropTypes.shape({
                    w120: PropTypes.string.isRequired
                }).isRequired
            }).isRequired
        }).isRequired
    };
    static defaultProps = {};

    render() {
        const { album } = this.props;

        return (
            <div className="component-album-details">
                <div className="user-avatar">
                    <img src={forceHttpsUri(album.user.avatar.w120)} />
                </div>
                <div className="user-username">
                    <Link to={getRouteByName('user', { username: album.user.username }).path}>
                        {album.user.username}
                    </Link>
                </div>
                <p className="album-description">{album.description}</p>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/public/album/Details/index.js